var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M248.7 37.4v186"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M1002.8 111.1c-2.5-3.4-5.6-6.3-9.2-8.5 3.4 2.6 6.5 5.4 9.2 8.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M943.9 130.4c0 18 14.6 32.6 32.6 32.6s32.6-14.6 32.6-32.6c0-7.2-2.3-13.9-6.3-19.2-2.8-3.1-5.8-5.9-9.2-8.5-5-3.1-10.9-4.9-17.2-4.9-17.9 0-32.5 14.6-32.5 32.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M882.2 89.2c-1.2 0-2.4.1-3.6.2h7.2c-1.2-.1-2.4-.2-3.6-.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M775.3 37.4v186M49.6 376.7h926.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M1019.3 221.1c-1.8-16.3-15.6-29-32.4-29-18 0-32.6 14.6-32.6 32.6v729.6H69.7V154.4h812.5c18 0 32.6-14.6 32.6-32.6 0-16.8-12.7-30.6-29-32.4H69.7c-35.9 0-65 29.1-65 65v799.9c0 35.9 29.1 65 65 65h884.6c35.9 0 65-29.1 65-65v-726c.1-1.2.2-2.4.2-3.6s-.1-2.4-.2-3.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M455.5 547h110M720.3 547h110M192.2 547h110M455.5 685h110M720.3 685h110M192.2 685h110M455.5 823h110M192.2 823h110"
  })));
}

export default SvgCalendar;